import GetClientButton from './GetClientButton';

export default GetClientButton;
